import { TFunction } from 'i18next'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'

export const getDocumentApprovalNotification = (documentType: InvoiceDocumentType, t: TFunction) => {
  switch (documentType) {
    case InvoiceDocumentType.CreditNote:
      return t('external_invoices.credit_note_approved')
    case InvoiceDocumentType.Quote:
      return t('quotes.quote_approved')
    case InvoiceDocumentType.Invoice:
    default:
      return t('external_invoices.invoice_approved')
  }
}
